import styled, { keyframes } from 'styled-components';
import { Divider as StormDivider, Link, SurfaceLight } from '@amzn/storm-ui';
import { inkwell } from 'src/colors';

interface SideNavWrapperProps {
  isOpen: boolean;
  isRtl: boolean;
}

export const SideNavWrapper = styled(SurfaceLight)<SideNavWrapperProps>`
  box-sizing: border-box;
  position: absolute;
  top: 0;
  display: block;
  height: 100%;
  background-color: rgb(251, 251, 252);
  box-shadow: 6px 0 4px -4px rgba(0, 0, 0, 0.1);
  z-index: -1;
  text-align: start;
  overflow-x: hidden;
  width: 300px;
  opacity: 0;

  /*! @noflip */
  ${({ isRtl, isOpen }) => {
    if (!isRtl && !isOpen) {
      return `left: -240px;`;
    } else if (isRtl && !isOpen) {
      return `right: -240px;`;
    } else if (!isRtl && isOpen) {
      return `left: 60px; /*! @noflip */ transition: left .25s ease-out, opacity .15s ease-out; opacity: 1;overflow-y: auto;`;
    } else if (isRtl && isOpen) {
      return `right: 60px; /*! @noflip */ transition: right .25s ease-out, opacity .15s ease-out; opacity: 1; overflow-y: auto;`;
    }
  }}
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 10%;
  }
`;
export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 60px;
  right: 0;
  bottom: 0;
  background-color: ${inkwell};
  z-index: 51;
  opacity: 10%;
  animation: ${fadeIn} 0.25s ease-out 0;
`;

export const TitleWrapper = styled.div`
  position: relative;
  color: rgb(35, 47, 63);
  font-size: 18px;
  font-weight: bold;
  padding: ${({ theme }) => theme.spacing.medium} 12px;
  margin-bottom: 3px;
`;

export const SubTitleWrapper = styled.div`
  color: rgb(35, 47, 63);

  &&& {
    font-size: 12px;
  }

  font-weight: bold;
  padding: 12px 12px;
  line-height: 1.333;
  margin-bottom: 3px;
`;

export interface ItemWrapperProps {
  isSelected: boolean | undefined;
}

export const SideNavLinkWrapper = styled(Link)`
  flex: 1;

  &&& {
    font-size: 15px;
  }

  line-height: 1.333;
  padding: ${({ theme }) => theme.spacing.base} 12px;

  &&&& {
    color: ${({ theme }) => theme.nav.link.color};
    text-decoration: ${({ theme }) => theme.nav.link.textDecoration};

    &:hover {
      color: ${({ theme }) => theme.nav.link.color};
      text-decoration: ${({ theme }) => theme.nav.link.textDecoration};
    }

    &:focus {
      outline-offset: 0;
    }
  }

  & > i {
    margin-inline: 8px;
  }

  border-radius: 3px;
`;

export const GroupWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacing.base};
  margin-right: ${({ theme }) => theme.spacing.base};
`;

export const Divider = styled(StormDivider)`
  margin: ${({ theme }) => theme.spacing.medium} 12px;
`;

export const ItemWrapper = styled.div<{ isSelected: boolean | undefined }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
  margin-bottom: 3px;
  ${(props) =>
    props.isSelected
      ? `
  background-color: rgba(35, 47, 63, 0.1);
`
      : ''};

  [id^='non-landing-app'] {
    display: none;
  }

  &&&:hover,
  &&&:focus-within {
    color: ${({ theme }) => theme.nav.link.color};
    text-decoration: ${({ theme }) => theme.nav.link.textDecoration};
    background-color: rgba(35, 47, 63, 0.05);

    [id^='non-landing-app'] {
      display: inline-block;
    }
  }
`;
